import React from 'react';
import { DialogTitle, Grid, makeStyles, Typography } from '@material-ui/core';
import { ITheme } from '../../themes/custom/ITheme';
import CloseIcon from '@material-ui/icons/Close';
import { useMediaQuery } from '@mui/material';
import theme from '../../themes/GlobalTheme';
import clsx from 'clsx';

const useStyles = makeStyles((theme: ITheme) => {
    return {
        dialog: {
            padding: '2rem',
        },
        dialogTitle: {
            height: '48px',
            padding: '0px 37px',
            lineHeight: '48px',
        },
        dialogTitleMobile: {
            padding: '0px 10px',
        },
        back: {
            fontSize: '15px',
            cursor: 'pointer',
        },
        h6: {
            textAlign: 'center',
        },
        closeButton: {
            color: theme.custom.palette.secondary,
            cursor: 'pointer',
            marginTop: '12px',
        },
    };
});

interface Props {
    handleOnClose: () => void;
    backText?: string;
    centered?: boolean;
    closeIcon?: boolean;
    overrideChildren?: boolean;
}

const KapinuaDialogTitle: React.FC<Props> = (props) => {
    const classes = useStyles();
    const {
        backText,
        closeIcon,
        handleOnClose,
        children,
        centered,
        overrideChildren,
    } = props;
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <DialogTitle
            id="max-width-dialog-title"
            className={clsx(
                classes.dialogTitle,
                isMobile && classes.dialogTitleMobile
            )}
        >
            {overrideChildren && <React.Fragment>{children}</React.Fragment>}
            {!overrideChildren && (
                <Grid
                    justifyContent={centered ? 'center' : 'space-between'}
                    container
                >
                    <Grid item>
                        <Typography className={classes.h6} variant="h6">
                            {children}
                        </Typography>
                    </Grid>
                    {backText && (
                        <Grid item>
                            <span
                                className={classes.back}
                                onClick={handleOnClose}
                            >
                                {backText}
                            </span>
                        </Grid>
                    )}
                    {closeIcon && (
                        <Grid item>
                            <CloseIcon
                                className={classes.closeButton}
                                onClick={handleOnClose}
                            />
                        </Grid>
                    )}
                </Grid>
            )}
        </DialogTitle>
    );
};

export default KapinuaDialogTitle;
